import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import '../../styles/errors.scss';

function ServerErrorPage() {
  const { t } = useTranslation();

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="error-page">
      <Helmet>
        <title>{t('errors.server.title')} | 500</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Navbar />
      <main className="error-page__main" id="main-content">
        <div className="error-page__card">
          <div className="error-page__code" aria-hidden="true">
            500
          </div>
          <h1 className="error-page__title">{t('errors.server.title')}</h1>
          <p className="error-page__description">{t('errors.server.description')}</p>
          <div className="error-page__actions">
            <Button variant="outline-light" type="button" onClick={handleReload}>
              {t('errors.server.cta')}
            </Button>
            <Button as={Link} variant="primary" to="/">
              {t('errors.server.ctaHome')}
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default ServerErrorPage;
